<template>
    <div class="mt-2">
        <div v-if="shouldDisplayPXFMention && pxfLegalMentionsText">
            <span class="fw-bold small" v-html="pxfLegalMentionsText" />
        </div>
    </div>
</template>

<script>
export default {
    name: "PxfDescription",
    props: {
        shouldDisplayPXFMention: {
          type: Boolean,
          required: false
        },
        pxfLegalMentionsText: {
          type: String,
          default: undefined
        }
    }
}
</script>

<style scoped>

</style>
